import React from 'react';
import "./propertylist.css"
import Navbar from '../components/navbar/navbar';
import arrow from "../assets/arrow.svg"
import range from "../assets/range.svg"
import FilterTitle from '../components/filtertitle/filtertitle';
import Type from '../components/types/type';
import Dropbox from '../components/dropbox/dropbox';
import Blackbtn from '../components/blackbtn/blackbtn';
import Prop from '../components/property/prop';
import house1 from "../assets/house1.png"
import house2 from "../assets/house02.png"
import house3 from "../assets/house03.png"
import icon1 from "../assets/icon01.svg"
import icon2 from "../assets/icon02.svg"
import icon3 from "../assets/icon03.svg"
import Footer from '../components/sections/footer';

const PropList = () => {
    return ( 
        <>
          <Navbar />
          <div className="mainsection">
          <div className="sectionwrap">

             <div className="column1">
               <div className="branches">
                    <span>Home</span>
                    <img src={arrow} alt="" />
                    <h6>Properties</h6>
               </div>

               <div className="titlelistprop">
                    <h1>Available Properties</h1>
                    <p>Discover your perfect home from our exclusive listings</p>
               </div>               
             <div className="filters">
                    <div className="price">
                         <FilterTitle title="Price Range" />
                     <div className="range">
                              <img src={range} alt="" />
                              <div className="pricenum">
                                   <span>$0</span>
                                   <span>$0.5M</span>

                              </div>
                         </div>

                    </div>


                         <div className="typecont">
                          <FilterTitle title="Property Type" />

                          <div className="typeoptions">
                              <Type text="House"/>
                              <Type text="Apartment"/>
                              <Type text="Villa"/>
                              <Type text="Penthouse"/>
                              <Type text="Townhouse"/>

                          </div>

                         </div>

                         <div className="filtertype">
                              <FilterTitle title="Bedrooms" />
                              <Dropbox text="Any" />
                         </div>

                         <div className="filtertype">
                              <FilterTitle title="Bathrooms" />
                              <Dropbox text="Any" />
                         </div>

                         <div className="filtertype">
                              <FilterTitle title="Location" />
                              <Dropbox text="All Locations" />
                         </div>
                         <div className="filterbtnss">

                         <Blackbtn name="Apply Filters" css1="blackbtnf" />
                         <div className="filterbtn">
                         <Blackbtn  name="Show filters" css1="whitebtn2"/>

                         </div>
                         </div>

             </div>
             </div>

             <div className="propertiesgrid">
               <h4>Showing <span>9</span> properties</h4>
               <div className="gridcont">
                 <div className="grid">
                    <Prop img={house1} propname='Modern Apartment' desc='A stylish apartment in the heart of the city with stunning views.' offer1={icon1} offer1num='3 Beds' offer2={icon2} offer2num='2 Baths' offer3={icon3} offer3num='1500 sqft' ofstyle="offerlist" />
                    <Prop img={house2} propname='Luxury Villa' desc='A spacious villa with panoramic views and premium amenities.' offer1={icon1} offer1num='5 Beds' offer2={icon2} offer2num='3 Baths' offer3={icon3} offer3num='3000 sqft' ofstyle="offerlist" />
                    <Prop img={house3} propname='Cozy Cottage' desc='A charming cottage nestled in a peaceful countryside setting.' offer1={icon1} offer1num='2 Beds' offer2={icon2} offer2num='1 Bath' offer3={icon3} offer3num='800 sqft' ofstyle="offerlist"/>
                    <Prop img={house1} propname='Modern Apartment' desc='A stylish apartment in the heart of the city with stunning views.' offer1={icon1} offer1num='3 Beds' offer2={icon2} offer2num='2 Baths' offer3={icon3} offer3num='1500 sqft' ofstyle="offerlist" />
                    <Prop img={house2} propname='Luxury Villa' desc='A spacious villa with panoramic views and premium amenities.' offer1={icon1} offer1num='5 Beds' offer2={icon2} offer2num='3 Baths' offer3={icon3} offer3num='3000 sqft' ofstyle="offerlist" />
                    <Prop img={house3} propname='Cozy Cottage' desc='A charming cottage nestled in a peaceful countryside setting.' offer1={icon1} offer1num='2 Beds' offer2={icon2} offer2num='1 Bath' offer3={icon3} offer3num='800 sqft' ofstyle="offerlist"/>
                    <Prop img={house1} propname='Modern Apartment' desc='A stylish apartment in the heart of the city with stunning views.' offer1={icon1} offer1num='3 Beds' offer2={icon2} offer2num='2 Baths' offer3={icon3} offer3num='1500 sqft' ofstyle="offerlist" />
                    <Prop img={house2} propname='Luxury Villa' desc='A spacious villa with panoramic views and premium amenities.' offer1={icon1} offer1num='5 Beds' offer2={icon2} offer2num='3 Baths' offer3={icon3} offer3num='3000 sqft' ofstyle="offerlist" />
                    <Prop img={house3} propname='Cozy Cottage' desc='A charming cottage nestled in a peaceful countryside setting.' offer1={icon1} offer1num='2 Beds' offer2={icon2} offer2num='1 Bath' offer3={icon3} offer3num='800 sqft' ofstyle="offerlist"/>
                 </div>

                 <div className="paging">

                 </div>

               </div>
             </div>

          </div>
          </div>
          <Footer />
        </>
     );
}
 
export default PropList;